import { AlertTriangle, Inbox, RefreshCw } from "lucide-react";

export function SkeletonCards({ count = 6 }) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-px bg-border" data-testid="intel-loading">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="bg-background p-6 md:p-8 animate-pulse space-y-4">
          <div className="flex gap-3">
            <div className="h-5 w-16 bg-muted" />
            <div className="h-5 w-28 bg-muted" />
          </div>
          <div className="h-7 w-4/5 bg-muted" />
          <div className="h-3 w-full bg-muted" />
          <div className="h-3 w-11/12 bg-muted" />
          <div className="h-3 w-2/3 bg-muted" />
        </div>
      ))}
    </div>
  );
}

export function EmptyState({ title = "Nothing here yet", body, action }) {
  return (
    <div data-testid="intel-empty" className="border border-dashed border-border p-12 md:p-20 text-center">
      <Inbox className="mx-auto text-muted-foreground" size={28} />
      <div className="mt-5 font-heading font-black uppercase tracking-tight text-xl md:text-2xl">{title}</div>
      {body && <p className="mt-3 text-sm text-muted-foreground max-w-[44ch] mx-auto">{body}</p>}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}

export function ErrorState({ onRetry, message }) {
  return (
    <div data-testid="intel-error" className="border border-destructive/50 bg-destructive/5 p-10 md:p-16 text-center">
      <AlertTriangle className="mx-auto text-destructive" size={28} />
      <div className="mt-5 font-heading font-black uppercase tracking-tight text-xl">Feed unavailable</div>
      <p className="mt-3 text-sm text-muted-foreground max-w-[44ch] mx-auto">
        {message || "The intelligence API did not respond. Cached data will return once the backend is reachable."}
      </p>
      {onRetry && (
        <button
          data-testid="intel-retry-button"
          onClick={onRetry}
          className="mt-6 inline-flex items-center gap-2 border border-border px-5 py-3 font-mono text-[11px] uppercase tracking-[0.2em] hover:border-accent hover:text-accent transition-colors"
        >
          <RefreshCw size={13} /> Retry
        </button>
      )}
    </div>
  );
}
